import type { RouteType } from "../types/routeBuilder";

/** Temporary backend routes are identified by their persisted expiration. */
export function persistedRouteType(route: {
  expiresAt?: string | null;
}): RouteType {
  return route.expiresAt ? "temporary" : "recurring";
}
